import clsx from "clsx";
import BaseActionModal, { BaseActionModalProps } from "./BaseActionModal";
import { HTMLProps } from "react";

/******
 *
 * When using this modal - please wrap Content (minus the button) in ActionModalContentWrapper
 * it will add the design requested padding to the content you put in.
 * You have to add the Button you'd like inside the children element.
 * Please see src/routes/design-system/routes/modal/ExampleActionModal.tsx for an example
 *
 ****/
type Props = BaseActionModalProps;

const ActionModal: React.FC<Props> = ({ children, ...props }) => {
  return <BaseActionModal {...props}>{children}</BaseActionModal>;
};

type ActionModalWrapperProps = HTMLProps<HTMLFormElement> & {
  children?: React.ReactNode;
};

export const ActionModalWrapper: React.FC<ActionModalWrapperProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <form
      className={clsx(
        "flex flex-grow flex-col justify-between dark",
        className,
      )}
      {...props}
    >
      {children}
    </form>
  );
};

type ActionModalContentWrapperProps = React.PropsWithChildren<{
  className?: string;
}>;

export const ActionModalContentWrapper: React.FC<
  ActionModalContentWrapperProps
> = ({ children, className }) => (
  <div className={clsx("px-9 pb-[26px]", className)} id="modal-content">
    {children}
  </div>
);
export default ActionModal;
